import type { HNCoreFrontendWebAppInvitation, HNCoreFrontendWebForside, HNCoreFrontendWebFeilmeldinger } from '../types/Resources';

import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { type ResourceItem, createResourcesApi } from '@helsenorge/framework-utils/resources';

import appResources from './HN.CoreFrontend.Web.AppInvitation.nb-NO.json';
import feilmeldinger from './HN.CoreFrontend.Web.Feilmeldinger.nb-NO.json';
import defaultResources from './HN.CoreFrontend.Web.Forside.nb-NO.json';
import Projects from '../constants/projects';

type ForsideResources = HNCoreFrontendWebAppInvitation | HNCoreFrontendWebForside | HNCoreFrontendWebFeilmeldinger;

export const getBundledResources = (projectName: string, language: LanguageLocales): ForsideResources | undefined => {
  if (projectName === Projects.AppInvitation && language === LanguageLocales.NORWEGIAN) {
    return appResources satisfies HNCoreFrontendWebAppInvitation;
  }

  if (projectName === Projects.Forside && language === LanguageLocales.NORWEGIAN) {
    return defaultResources satisfies HNCoreFrontendWebForside;
  }
  if (projectName === Projects.Feilmeldinger) {
    return feilmeldinger satisfies HNCoreFrontendWebFeilmeldinger;
  }
};

export const fetchResources = async <T extends ResourceItem>(projectName: string, language: LanguageLocales): Promise<T> => {
  try {
    const resources: { default: T } = await import(`./${projectName}.${language}.json`);

    return resources.default;
  } catch (error) {
    throw new Error(`Failed to load resources for ${projectName} in ${language}: ${error}`);
  }
};

export const { resourcesApi, useResources, useSuspenseResources } = createResourcesApi<ForsideResources>({
  fallbackLanguage: LanguageLocales.NORWEGIAN,
  getBundledResources: getBundledResources,
  fetchResources: fetchResources,
  useFallbackForMissingTexts: true,
});
